import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShift: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shift"><path d="M12.5496 2.23966C12.4077 2.08684 12.2086 2 12 2C11.7915 2 11.5923 2.08684 11.4504 2.23966L1.70042 12.7397C1.49744 12.9583 1.4433 13.2764 1.56254 13.5498C1.68177 13.8232 1.95172 14 2.25002 14H6.11844V20.25C6.11844 20.6642 6.45422 21 6.86844 21H17.1316C17.5458 21 17.8816 20.6642 17.8816 20.25V14H21.75C22.0483 14 22.3183 13.8232 22.4375 13.5498C22.5567 13.2764 22.5026 12.9583 22.2996 12.7397L12.5496 2.23966Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShift;
